import React, { useEffect, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getUrlToManagePage, getUrlToLoginPage } from "../urls";
import { SpinnerFullPage } from 'shared/components/SpinnerFullPage/index.js';
import { REDIRECTABLE_URLS } from "config";
import { isLoggedIn, getUserTokenInfo } from "api/auth-storage";

const MANAGE_PAGE_URL = getUrlToManagePage();
const LOGIN_PAGE_URL = getUrlToLoginPage();

export function LoginCallbackPage () {
  const navigate = useNavigate();
  const isAuthenticated = isLoggedIn();
  const [urlSearchParams] = useSearchParams();

  const loginPageUrl = LOGIN_PAGE_URL + '?' + urlSearchParams.toString();

  const redirectAfterLogin = useCallback(async () => {
    const redirectTo = urlSearchParams.get('redirectTo');
    if (!redirectTo) return navigate(MANAGE_PAGE_URL);
    if (REDIRECTABLE_URLS.every(url => url !== redirectTo)) return navigate(MANAGE_PAGE_URL);
    const tokenInfo = getUserTokenInfo();
    if (!tokenInfo) return navigate(loginPageUrl);
    const { token, expiresAt } = tokenInfo;
    const stateParam = urlSearchParams.get('state');
    const authInfoPart = `token=${token}&expiresAt=${expiresAt}`;
    const statePart = stateParam ? `&state=${stateParam}` : ''
    window.location.replace(`${redirectTo}?${authInfoPart}${statePart}`);
  }, [urlSearchParams, loginPageUrl]);

  useEffect(() => {
    if (!isAuthenticated) navigate(loginPageUrl);
    redirectAfterLogin();
  }, [isAuthenticated, loginPageUrl, redirectAfterLogin]);

  return <SpinnerFullPage />;
}
